// test1141
(1141 && 0);
